import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MailchimpEmbed } from '../elements/mailchimp-embed';

const cls = classNames('slice-mailchimp-embed');

export type SliceMailchimpEmbedProps = Classable & HasChildren & {
  entity?: Slice;
};

type ContainerProps = {};

const ContainerStyles = breakpoints({
  base: css``,
});

const My = {
  Container: styled(MailchimpEmbed)<ContainerProps>`${ContainerStyles}`,
};

export const SliceMailchimpEmbed: Shapeable.FC<SliceMailchimpEmbedProps> = (props) => {
  const { className } = props;

  return (
    <My.Container className={cls.name(className)} />
  )
};

SliceMailchimpEmbed.cls = cls;